"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
function deleteFromCache(emailToDelete) {
    var i = 0;
    var match = false;
    if (store_1.default.recipientCache) {
        while (!match && i < store_1.default.recipientCache.length) {
            var email = store_1.default.recipientCache[i].EmailAddress;
            if ((email.EmailAddress && email.EmailAddress == emailToDelete.EmailAddress) ||
                (email.Name && email.Name == emailToDelete.Name)) {
                match = true;
                store_1.default.recipientCache.splice(i, 1);
            }
            else {
                i++;
            }
        }
    }
    return match;
}
exports.default = deleteFromCache;
//# sourceMappingURL=deleteFromCache.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-cache/lib/selectors/deleteFromCache.js
// module id = 3392
// module chunks = 2 3